module.exports = __webpack_public_path__ + "img/workbench_5.b67c8b70.png";